import type { FaireProductEntity } from "../../entity_types/product";

export const p_heefhd2uqc: FaireProductEntity = {
  token: "p_heefhd2uqc",
  type: "product",
  name: "Bridget Sweater - Strata (Faire Pre-Order)",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/08fc4e49a5e1e241fc642301b96597e13e54499affb34234243358cd592794db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/031830e0fdae94d632451159dfe2de59066c78dcd5e1dfa6c87a7cab8c215f48.jpeg",
    "https://cdn.faire.com/fastly/5c650f53fbc2c8573fb7133c232e18dfbfa2599fe6e89cf49c98d54033a8fe02.jpeg",
    "https://cdn.faire.com/fastly/f6e69845813b3558132a10db52784ea560d4433eb23347d5973dc37194c9a097.jpeg",
    "https://cdn.faire.com/fastly/4c47203bf761400daddc5f41c181a65ccdf31b09b35cf0b039a925572d038395.jpeg",
    "https://cdn.faire.com/fastly/9995aac6aef16b7c5b15898cf015c4a875233f991ad81166a1cd6a253cc84eb4.jpeg",
    "https://cdn.faire.com/fastly/1b471cc5cca75b8e90567cbb282fd5fcb04f712f807542195af4e2cd389d5ddc.jpeg",
    "https://cdn.faire.com/fastly/4911cdbd20745e761922ab121dcc98c2063be32438ab4bf7b9d2e7f5aeaebafc.jpeg"
  ],
  priceDollars: 111.6,
  description: "A grid that shifts as you look at it, borrowed from the op art of Bridget Riley. Double knit means two faces worked as one — that is where the warmth comes from, without the stiffness.\n\n * 100% Merino Wool \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity \n * Relaxed and straight through the body, in a v-neck ",
  tags: [],
  msrpDollars: 248,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:29.167Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
